'use client';

import { useEffect, useRef } from 'react';

export default function MouseTiltWrapper({ children, multiplier = 0.15 }) {
  const ref = useRef(null);
  const mouseRef = useRef({ x: 0, y: 0, targetX: 0, targetY: 0 });

  useEffect(() => {
    let animationId;
    let isActive = false;
    
    const update = () => {
      const { targetX, targetY, x, y } = mouseRef.current;
      const dx = targetX - x;
      const dy = targetY - y;
      
      // Stop animating if we're close enough to the target
      if (Math.abs(dx) < 0.01 && Math.abs(dy) < 0.01) {
        isActive = false;
        return;
      }
      
      mouseRef.current.x += dx * 0.1;
      mouseRef.current.y += dy * 0.1;
      
      if (ref.current) {
        ref.current.style.transform = `translate(${mouseRef.current.x * multiplier}px, ${mouseRef.current.y * multiplier}px)`;
      }
      animationId = requestAnimationFrame(update);
    };

    const handleMouseMove = (e) => {
      const { innerWidth, innerHeight } = window;
      const x = (e.clientX - innerWidth / 2) / (innerWidth / 2);
      const y = (e.clientY - innerHeight / 2) / (innerHeight / 2);
      mouseRef.current.targetX = x * 10;
      mouseRef.current.targetY = y * 10;
      
      if (!isActive) {
        isActive = true;
        update();
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (animationId) cancelAnimationFrame(animationId);
    };
  }, [multiplier]);

  return (
    <div ref={ref} className="w-full sm:w-auto">
      {children}
    </div>
  );
}
